













import { Component, Vue, Prop } from 'vue-property-decorator'
import { cloudFunction } from '@/lib/parse-service'
import Header from '@/components/Header.vue'

@Component<RequestDeletionView>({
  components: {
    Header,
  }
})
export default class RequestDeletionView extends Vue {
  email = ''
  error = ''
  isCompleted = true
  async requestDeletion() {
    this.error = ''
    try {
      const res = await cloudFunction('requestDeletion', {
        email: this.email
     })    
     this.isCompleted = true
    } catch (err) {
      this.error = 'Ungültige Email'
    }
  }
}
